// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1emgk","content":"styles_content__26glL"};